"use client";

import { FaTwitter, FaLinkedin } from "react-icons/fa";
import styles from "./ShareButtons.module.css";

type SharePlatform = "twitter" | "linkedin";
type ShareVariant = "light" | "dark";

function getShareUrl(platform: SharePlatform, pageUrl: string): string {
  switch (platform) {
    case "twitter":
      return `https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}`;
    case "linkedin":
      return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(pageUrl)}`;
    default: {
      const _never: never = platform;
      return _never;
    }
  }
}

function getWrapClass(variant: ShareVariant): string {
  switch (variant) {
    case "light":
      return styles.wrap;
    case "dark":
      return `${styles.wrap} ${styles.dark}`;
    default: {
      const _never: never = variant;
      return _never;
    }
  }
}

export default function ShareButtons({
  variant = "light",
}: {
  variant?: ShareVariant;
}) {
  const handleShareClick = (platform: SharePlatform) => {
    const shareUrl = getShareUrl(platform, window.location.href);
    window.open(shareUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={getWrapClass(variant)}>
      <p className={styles.label}>Share</p>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.button}
          onClick={() => handleShareClick("linkedin")}
        >
          <FaLinkedin aria-hidden="true" />
          LinkedIn
        </button>
        <button
          type="button"
          className={styles.button}
          onClick={() => handleShareClick("twitter")}
        >
          <FaTwitter aria-hidden="true" />
          X
        </button>
      </div>
    </div>
  );
}
